// Relative to the axios base URL, which already appends /api.
export const CURRENCY_ENDPOINTS = {
	/** Currencies + rates + whether this deployment runs dual currency. */
	list: "Currency/list",
	/** Legacy three-column shape (id, description, rate) that CurrencyManagement binds to. */
	legacyList: "Currency",
	updateRate: "Currency/update",
} as const;
